import { Component, EventEmitter, inject, OnDestroy, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import {WmsFeatureDirective} from "@wms/directives";
import {
  BaseComponent,
  WmsDialogBodyComponent,
  WmsDialogComponent,
  WmsDialogFooterComponent,
  WmsDialogHeaderComponent
} from "@wms/components";
import {
  DeploymentProfilesService,
  DialogService,
  NotificationService, PageTemplatesService,
  PrefabService, StudioFactory,
  StudioService,
  UserService
} from "@wms/services";
import {
  ExportProjectShellDialogComponent
} from "@wms/app/artifact-export/components/export-ProjectShell-dialog/export-ProjectShell-dialog.component";
import {
  PublishArtifactToTeamDialogComponent
} from "@wms/app/artifact-export/components/publish-artifact-to-team-dialog/publish-artifact-to-team-dialog.component";
import {VcsService} from "@wms/app/vcs/services/vcs.service";
import {VcsAPIService} from "@wms/app/vcs/services/vcs-api/vcs-api.service";
import { WmsWorkspaceManagerService } from "@wms/workspace";
import {Subscription} from "rxjs";
import {
  DeployConfirmDialogComponent
} from "@wms/app/deployment/wms-deploy-dialog/deploy-confirm-dialog/deploy-confirm-dialog.component";
import {DeployDialogComponent} from "@wms/app/deployment/wms-deploy-dialog/deploy-dialog/deploy-dialog.component";
import {
  WmsPushChangesDialogComponent
} from "@wms/app/deployment/wms-deploy-dialog/wms-push-changes-dialog/wms-push-changes-dialog.component";
import {DeploymentService} from "@wms/app/deployment/deployment.service";
import {PrefabPublishComponent} from "@wms/app/prefab-publish/prefab-publish.component";

@Component({
  selector: 'wms-export-menu',
  standalone: true,
  imports: [CommonModule, BsDropdownModule, WmsFeatureDirective, ExportProjectShellDialogComponent, WmsDialogBodyComponent, WmsDialogComponent, WmsDialogFooterComponent, WmsDialogHeaderComponent, PublishArtifactToTeamDialogComponent, DeployConfirmDialogComponent, DeployDialogComponent, WmsPushChangesDialogComponent, PrefabPublishComponent],
  templateUrl: './export-menu.component.html',
  styleUrls: ['./export-menu.component.less']
})
export class ExportMenuComponent extends BaseComponent implements OnInit, OnDestroy{
  @Output() getReference = new EventEmitter<any>();
  profiles: any;
  expanded: boolean = false;
  expandedWC: boolean = false;
  exportType: any;
  exportOptions: any;
  exportFileName: any;
  exportDialogCaption: string;
  exportDialogContent: string;
  zipFileId: string
  switch: any;
  expandExportReportSubmenu: boolean = false;

  notificationService: NotificationService
  selectedOrganization: any;
  studioService: StudioService;
  user: any;
  projectDetails: any;
  dialogService: DialogService;
  userService: UserService;
  deploymentProfiles: DeploymentProfilesService;
  prefabService: PrefabService;
  pageTempplateService: PageTemplatesService;
  dialogHeader: any;
  artifactType: any;
  vcsService: VcsService;
  vcsApiService: VcsAPIService;
  wsManager: WmsWorkspaceManagerService;
  jobType: "";
  private profilesSubscription: Subscription;
  protected isPrism: boolean;
  isApplicationType: boolean;
  studioFactory:StudioFactory
  deploymentService: DeploymentService

  constructor() {
    super();
    this.vcsService = inject(VcsService);
    this.dialogService = inject(DialogService);
    this.studioService = inject(StudioService);
    this.userService = inject(UserService);
    this.deploymentProfiles = inject(DeploymentProfilesService);
    this.prefabService = inject(PrefabService);
    this.pageTempplateService = inject(PageTemplatesService);
    this.projectDetails = this.projectService.getDetails();
    this.isPrism = this.projectService.isPrism();
    this.vcsApiService = inject(VcsAPIService);
    this.wsManager = inject(WmsWorkspaceManagerService);

    this.studioFactory = inject(StudioFactory);
    this.notificationService = inject(NotificationService);
    this.deploymentService = inject(DeploymentService);
    this.user = this.userService.get();
    this.isApplicationType = this.projectService.isApplicationType();
   this.eventManager.exportProjectAsShellObservable().subscribe(() => {
     this.vcsService.checkRepoStatus(this.openPublishToTeamDialog.bind(this));
    });

    this.profilesSubscription = this.eventManager.profilesObservable().subscribe((value)=>{
      this.profiles = value
    });
    // this.dialogService.storeDialogRef = true;
  }

  ngOnInit() {
    this.deploymentProfiles.list(this.projectDetails.id).then((profileList: any) => {
      this.profiles = profileList
    })
    this.getReference.emit(this)
  }

  saveAndExport(type: string, profile?: any) {
    this.getReference.emit(this);
    this.wsManager.triggerSaveImmediately = true;
    this.wsManager.saveActiveWs.next(() => {
      if (type === 'projectAsZip') {
        this.exportProject();
      }
      if (type === 'exportAsAngularZip') {
        this.downloadAngularAppZip(type);
      }
      if (type === 'exportAsReactZip') {
        this.downloadReactZip(type);
      }
      if (type === 'projectAsWAR') {
        this.downloadProject(profile, type);
      }
      if (type === 'projectAsWC') {
        this.downloadProject(profile, type);
      }
      if (type === 'prefabAsZip') {
        this.saveAndExportPrefab();
      }
      if (type === 'templateBundleAsZip') {
        this.saveAndExportTemplateBundle()
      }
    })
  }

  exportProject(): void {
    this.exportType = 'ZIP';
    this.exportFileName = this.projectDetails.name + this.projectDetails.version + '.' + this.exportType;
    let details = {
      'exportType': this.exportType,
      'targetName': this.projectDetails.name,
      'projectId': this.projectDetails.id
    }
    this.projectService.export(details).then((responce) => {
      this.exportDialogCaption = this.locale.LABEL_EXPORT_ZIP_PROJECT
      this.exportDialogContent = this.locale.LABEL_EXPORT_PROJECT_ZIP_DIALOG_TEXT + this.exportFileName
      this.zipFileId = responce.result
      this.dialogService.open('zipExportDialog')
    })
  }

  downloadProject(profile: any, type?: any) {
    this.exportType = type === "projectAsWC" ? 'WEBCOMPONENT' : 'WAR';
    this.exportFileName = this.projectDetails.name + '.' + this.exportType;
    this.jobType = type === "projectAsWC" ? this.locale.LABEL_WEB_COMPONENT_PROJECT : this.locale.LABEL_WAR_PROJECT ;
    let details = {
      'exportType': this.exportType,
      'targetName': this.projectDetails.name,
      'projectId': this.projectDetails.id,
      'profileName': profile
    }
    this.projectService.exportWar(details).then((response) => {
      this.dialogService.open('warExportDialog')
      this.eventManager.emitJobStatus(true)
    })
  }

  downloadAngularAppZip( type: any) {
    this.exportType = type
    this.exportFileName = this.projectDetails.name + '.' + this.exportType;
    this.jobType = this.locale.LABEL_ZIP_PROJECT_AS_ANGULAR ;
    let details = {
      'exportType': this.exportType,
      'projectId': this.projectDetails.id,
    }
    this.projectService.exportAsAngularZip(details).then((response) => {
      this.dialogService.open('warExportDialog')
      this.eventManager.emitJobStatus(true)
    })
  }
  /* Project as React Zip */
  downloadReactZip(type:any) {
    this.exportType = type;
    this.jobType = this.locale.LABEL_ZIP_PROJECT_AS_REACT ;
    this.projectService.exportAsReactZip().then((response) => {
      this.dialogService.open('warExportDialog')
      this.eventManager.emitJobStatus(true)
    })
  }

  saveAndExportPrefab() {
    let fileName = this.projectDetails.name + '.zip';
    let details = {
      'exportType': 'PREFAB',
      'targetName': this.projectDetails.name,
      'projectId': this.projectDetails.id
    }
    this.prefabService.export(details).then((responce) => {
      this.exportDialogCaption = this.locale.LABEL_EXPORT_ZIP_PREFAB;
      this.exportDialogContent = this.locale.LABEL_EXPORT_PREFAB_DIALOG_TEXT + fileName;
      this.zipFileId = responce.result;
      this.dialogService.open('zipExportDialog');
    })
  }

  saveAndExportTemplateBundle() {
    let fileName = this.projectDetails.name + '.zip';
    let details = {
      'exportType': 'TEMPLATEBUNDLE',
      'targetName': this.projectDetails.name,
      'projectId': this.projectDetails.id
    }
    this.pageTempplateService.export(details).then((responce) => {
      this.exportDialogCaption = this.locale.LABEL_EXPORT_ZIP_TEMPLATEBUNDLE;
      this.exportDialogContent = this.locale.LABEL_EXPORT_TEMPLATEBUNDLE_DIALOG_TEXT + fileName;
      this.zipFileId = responce.result;
      this.dialogService.open('zipExportDialog');
    })
  }

  initiateSaveProjectShell() {
    this.dialogService.open('DialogExportProjectAsProjectShell')
  }

  close(id: string) {
    this.dialogService.close(id);
    if(id === 'warExportDialog') {
      this.jobType = '';
    }
  }

  downloadZipFile(zipFileId: string) {
    window.location.href = '/file-service/' + zipFileId;
    this.dialogService.close('zipExportDialog')
  }

  saveAsProjectShell() {
    this.artifactType = "PROJECTSHELL";
    this.publishToTeam()
  }

  publishToTeam() {
    let syncAction = 'push';
    this.wsManager.triggerSaveImmediately = true;
    //save the workspace first and then show the dialog
    this.wsManager.saveActiveWs.next(() => {
      this.vcsApiService.loadChanges().then((fileList: any) => {
        if (!fileList.length) {
          //check for project vcs status before opening the publish to workspace dialog
          this.vcsService.checkRepoStatus(this.openPublishToTeamDialog.bind(this))
        } else {
          //if there are any local changes, show the VCS push dialog
          this.vcsService.exportProjectasShellDialog = true
          this.vcsService.openPushProjectDialog(this.openPublishToTeamDialog.bind(this))
        }
      }, (err) => {
        this.notificationService.show('error', this.locale["MESSAGE_ERROR_TITLE"], err);
      });
    });
  }

  openPublishToTeamDialog() {
    this.dialogHeader = this.artifactType !== 'PROJECTSHELL' ? (this.artifactType === 'PROJECTCORE' ? 'LABEL_PUBLISH_APPLICATION_TO_TEAMS' : 'LABEL_PUBLISH_' + this.artifactType + '_TEAM') : "LABEL_PUBLISH_PROJECTSHELL_TEAM";
    this.dialogService.open('publishArtifactToTeam')
  }

  publishThemeToTeam() {
    this.artifactType = "THEME";
    this.openPublishToTeamDialog();
  }

  /* Project as ReactNative Zip */
  rnMobileBuild() {
    this.projectService.exportForNativeMobileBuild({
      'projectId' : this.projectDetails.id
    }).then((responce) => {
      this.jobType = this.locale.LABEL_ZIP_REACTNATIVE;
      this.dialogService.open('warExportDialog')
      this.eventManager.emitJobStatus(true)
    })
  };

  /* Dependencies Report export */
  dependenciesReport(){
    this.projectService.exportDependenciesReport({
      'projectId' : this.projectDetails.id,
      'exportType' : 'PROJECTREPORT',
    }).then((responce) => {
      this.jobType = this.locale.LABEL_DEPENDENCIES_REPORT;
      this.dialogService.open('warExportDialog');
      this.eventManager.emitJobStatus(true);
    })
  }

  /* Project Summary Report PDF export */
  projectSummaryReport(){
    this.exportType = 'PDF';
    this.exportFileName = this.projectDetails.name + this.projectDetails.version + '.' + this.exportType;
    this.projectService.exportProjectSummaryReport().then((response) => {
      this.exportDialogCaption = this.locale.LABEL_EXPORT_PROJECT_SUMMARY_REPORT_PDF
      this.exportDialogContent = this.locale.LABEL_EXPORT_PROJECT_SUMMARY_REPORT_DIALOG_TEXT + this.exportFileName
      this.zipFileId = response.result
      this.dialogService.open('zipExportDialog')
    })
  }

  override ngOnDestroy() {
    if (this.profilesSubscription) {
      this.profilesSubscription.unsubscribe();
    }
  }

  reDeployToCloud(){
    this.deploymentService.reDeployToCloud()
  }
  showDeployStatus(){
    this.deploymentService.checkDeployStatus()
  }
  deployToCloud(){
    this.deploymentService.deployToCloud()
  }

  publishProjectAsCore(){
    this.wsManager.triggerSaveImmediately = true;
    this.wsManager.saveActiveWs.next(() => {
      if(this.projectService.teamProjectObject.vcsAccountDTO.mrFlowEnabled) {
        this.vcsApiService.validateNoChanges().then(() => {
          this.artifactType = 'PROJECTCORE';
          this.openPublishToTeamDialog();
        }, (error) => {
          if(error && error.status === 400 && error.error.errors.error[0].messageKey === "com.wavemaker.vcs$haveUnPushedChanges") {
            this.notificationService.show('error', this.locale['MESSAGE_ERROR_TITLE'], this.locale.MSG_ERROR_UNPUSHED_CHANGES);
          }
          if(error && error.status === 400 && error.error.errors.error[0].messageKey === "com.wavemaker.vcs$unMergedChanges") {
            this.notificationService.show('error', this.locale['MESSAGE_ERROR_TITLE'], this.locale.MSG_ERROR_UNMERGED_CHANGES);
          }
        });
      } else {
        this.vcsService.publishProjectAsCore = true;
        this.vcsService.openPushProjectDialog(()=> {
          this.vcsService.publishProjectAsCore = false
          this.artifactType = 'PROJECTCORE';
          this.openPublishToTeamDialog();
        });
      }
    });
  }



}
